import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Input from '../Input';
import ThankYou from '../ThankYou';
import Popup from '../Popup';

class PasswordResetRequest extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.state = {
			user_email: '',
			resetSent: false
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);

		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleSubmit(event) {
		const data = new FormData(event.target);
		var target = document.querySelector('.pp-button');

		this.loadingButton(target);

		this.Auth.passwordResetRequest(data)
			.then((result) => {
				console.log(result);
				this.removeLoadingButton(target);
				if (result.success === true) {
					this.setState({
						resetSent: true
					});
				} else {
					this.showMessage(result.message);
				}
			},
			(error) => {
				console.log(error);
				this.removeLoadingButton(target);
				this.showMessage("Check console for error");
			}
		);
		event.preventDefault();
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	loadingButton(target) {
		target.disabled = true;
		target.classList.add('pp-loading');
	}

	removeLoadingButton(target) {
		target.disabled = false;
		target.classList.remove('pp-loading');
	}

	render() {

		const { message } = this.state;

		return (
			<Page pageClass="pp-password-reset-page">

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				{!this.state.resetSent &&
					<PageSection className="pp-user-flow">

						<form id="resetpassword" className="pp-form-wrapper" onSubmit={this.handleSubmit}>
							<div className="pp-form-row">
								<Input
									type="text"
									htmlName="user_email"
									label="Email"
									placeholderText="Email Address"
									onChange={this.handleInputChange}
									value={this.state.user_email}
								/>
							</div>

							<div className="pp-action-buttons">
								<button type="submit" className="pp-button">Request Password Reset</button>
							</div>
						</form>

					</PageSection>
				}
				{this.state.resetSent &&
					<ThankYou
						className="pp-message"
						title="Please Check Your Email"
						message="A password reset request has been sent to your email address."
					/>
				}

			</Page>
		);
	}
}

export default PasswordResetRequest;



// WEBPACK FOOTER //
// ./src/components/pages/PasswordResetRequest.js